<template>
  <div class="col-social">
      <h5 class="text-center">
{{ cpLang('global.or_txt') }}
</h5>
      <a @click="login('facebook')" class="facebook-login" title="Facebook"><span>
        <!-- <i class="fab fa-facebook-f" /> -->
        {{ cpLang('login.facebook') }}</span></a>
      <a @click="login('google')" class="google-login" title="Google"><span>
        <!-- <i class="fab fa-google" /> -->
        {{ cpLang('login.google') }}</span></a>
      <a @click="login('linkedin')" class="linkedin-login" title="Linkedin"><span>
        <!-- <i class="fab fa-linkedin-in" /> -->
        {{ cpLang('login.linkedin') }}</span></a>
  </div>
</template>

<script>
import commonHelper from '~/assets/js/commonHelper.js'
export default {
  props: {
    open: Boolean
  },
  data: function() {
    return {
    }
  },
  computed: {
    redirect() {
      return (
        this.$route.query.redirect &&
        decodeURIComponent(this.$route.query.redirect)
      )
    },
    isCallback() {
      return Boolean(this.$route.query.callback)
    }
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    login: function (platform) {
      // save redirect uri to localstorage
      const uri = window.location.href.indexOf('registration') > -1 ? '/myjob' : window.location.href
      commonHelper.setLocalStorage('redirect_uri', uri)
      switch (platform) {
        case 'facebook': {
          const uri = process.env.OAUTH_FACEBOOK
          window.location.href = uri
          break
        }
        case 'google': {
          const uri = process.env.OAUTH_GOOGLE
          window.location.href = uri
          break
        }
        case 'linkedin': {
          const uri = process.env.OAUTH_LINKEDIN
          window.location.href = uri
          break
        }
      }
    }
  }
}
</script>
